module.exports = __webpack_public_path__ + "static/img/empty.6a5fcad8.png";